import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnTableConfig, FnTableMetaData, FnToasterService, TableAction } from 'foundation';
import { PosHttpService } from '../../../../../services/pos.http.service';
import { MQStatsMsg } from '../../../../../modal/entity.modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mq-stats-model',
  templateUrl: './mq-stats-model.component.html',
  styleUrl: './mq-stats-model.component.scss'
})
export class MqStatsModelComponent {

  constructor( @Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData,private dialogRef: MatDialogRef<MqStatsModelComponent>, private toaster: FnToasterService, private posHttpSvcs: PosHttpService) { }

  close() {
    this.dialogRef.close();
  }

  queueName : string = '';

  ngOnInit(): void {
    this.loadMessages();
    this.queueName = this.dialogData.queue;
  }

  ObjectHash: MQStatsMsg[] = [];

  loadMessages() {
      const requestMap = {
        mq: this.dialogData.mq,
        queue: this.dialogData.queue
      }
      this.posHttpSvcs.authPost('v1/ui/getMessages', 'getMessages', requestMap).subscribe((resp: any) => {
        if (resp.isError) {
          this.toaster.error(resp.message);
          return;
        }
        this.ObjectHash = resp.data;
      })
    }

  config: FnTableConfig = {
    uniqueKey: 'messageId',
    defaultSortKey: 'messageId',
    tableAction: new Subject<TableAction>(),
    hideAction: true
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'messageId',
      description: 'MessageID',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'correlationId',
      description: 'CorrelationID',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'priority',
      description: 'Priority',
      type: 'number',
      isSortable: true,
    },
    {
      key: 'timestamp',
      description: 'Timestamp',
      type: 'number',
      isSortable: true,
    },
    {
      key: 'type',
      description: 'Type',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'content',
      description: 'Content',
      type: 'string',
      isSortable: true,
    }
  ];
}

interface HwDialogData {
  queue: any;
  mq: any;

}
